import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionModel } from 'src/app/models/api/permission.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PermissionsEnum } from 'src/app/constants/settings.enum';
import { PermissionsService } from '../../permissions.service';
@Component({
  selector: 'app-hide-by-permission-wrapper',
  templateUrl: './hide-by-permission-wrapper.component.html'
})
export class PermissionWrapperComponent implements OnInit, OnDestroy {
  @Input() forPermission!: PermissionsEnum | string | boolean;
  @Input() showWhenHidden: boolean = false;
  permission: PermissionModel = new PermissionModel();
  isSystemAdmin: boolean = false;
  isWLAdmin: boolean = false;
  get hide(): boolean {
    // 'simple':
    // hide when hidden
    // but show when: systemadmin OR whitelabel admin AND it is not DISABLED
    return this.permission && this.permission.isHidden && !(this.showWhenHidden && (this.isSystemAdmin || (this.isWLAdmin && !this.permission.isDisabled)));
  }
  permissionsUpdatedSubscription: Subscription;
  authenticationServiceSubscription: Subscription;
  constructor(private authenticationService: AuthenticationService,
    private permissionsService: PermissionsService) {
    this.authenticationServiceSubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.isSystemAdmin = data.isSystemAdmin;
      this.isWLAdmin = data.isWhitelabelAdmin;
    });
    this.permissionsUpdatedSubscription = this.permissionsService.permissionsUpdated.subscribe(unneededValue => {
      this.getPermission();
    });
  }
  ngOnInit(): void {
    this.getPermission();
  }
  ngOnDestroy() {
    if (this.permissionsUpdatedSubscription) {
      this.permissionsUpdatedSubscription.unsubscribe();
    }
    if (this.authenticationServiceSubscription) {
      this.authenticationServiceSubscription.unsubscribe();
    }
  }
  private getPermission() {
    if(typeof this.forPermission === "boolean"){
      this.permission.isHidden = true;
    } else {
      this.permission = this.permissionsService.GetPermission(this.forPermission);
    }
  }
}